<template>
  <div>
    <Becomeavolunteer
      :isActive="isvolunteerDetails"
      :selectedvolunteer="selectedvolunteer"
      @close="handleClick"
    />
    <div class="lg:py-28 md:py-20 py-8">
      <!-- <img
        src="@/assets/images/line/linerespite2.svg"
        alt=""
        class="ml40p mob-hidden"
      /> -->
      <div class="lg:flex md:flex items-center">
        <div class="lg:w-1/2 md:w-1/2 w-full mob-hidden">
          <img
            src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/image/6.jpg"
            alt="aboutus"
            class="m-auto h-fit imgw-530px ml-10"
          />
        </div>
        <div class="lg:w-1/2 md:w-1/2 w-full lg:px-20 md:px-20 px-5">
          <div class="lg:mt-16 md:mt-16 mt-8">
            <p class="title sm-fsize16 md:font-normal lg:font-normal font-bold">
              Become a Service Provider
            </p>

            <p
              class="subtitle lg:pt-10 md:pt-10 pt-2 lh32px sm-lh26 sm-fsize13"
            >
              Partner with us and ease the challenges of caregiver. Help them
              plan the respite care they need.
            </p>
          </div>
          <div class="lg:pt-10 md:pt-10 pt-4">
            <base-button
              outline
              type="primary"
              class="md:px-10 lg:px-10 px-6 md:py-3 lg:py-3 py-1 fs16700 border-2"
              @click="handleClick('about-us')"
              >Apply Now</base-button
            >
          </div>
        </div>
        <div class="lg:w-1/2 md:w-1/2 w-full web-hidden">
          <img
            src="../../../assets/images/line/Doctor-pana 1.svg"
            alt="aboutus"
            class="m-auto smw-390px imgw-530px lg:ml-10 md:ml-10"
          />
        </div>
      </div>
      <!-- <div class="w-1/2">
        <h2>Post a Requirement</h2>
        <p>
          You can customize you respite care as per your need. It can be
          arranged of an afternoon or serveral days or weeks.care can be
          provided at home.in a healthcare facility, or at an adult day center.
        </p>
      </div>
      <img src="@/assets/images/line/bgline2.svg" alt="" /> -->
    </div>
  </div>
</template>

<script>
import Becomeavolunteer from "../../navbar/components/cg-becomevolunteerPopup.vue";

export default {
  components: {
    Becomeavolunteer,
  },
  data() {
    return {
      currentRoute: "",
      selectedpostrequirement: {},
      selectedvolunteer: {},

      isvolunteerDetails: false,
      isDetailsActive: false,
    };
  },
  methods: {
    handleClick(val = false, item = {}) {
      this.isvolunteerDetails = val;
      this.selectedvolunteer = item;
    },
  },
};
</script>

<style>
.top-130px {
  top: 130px;
}
@media (max-width: 640px) {
  .sm-top-40px {
    top: -40px;
  }
  .smw-390px {
    width: 390px !important;
  }
}

.ml40p {
  margin-left: -13rem;
}
.imgw-530px {
  width: 530px;
}
</style>
